import { render, staticRenderFns } from "./ShippingsList.vue?vue&type=template&id=39a31b38&"
import script from "./ShippingsList.vue?vue&type=script&lang=js&"
export * from "./ShippingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports